export default {"src":"/_next/static/media/AES.43236e84.svg","height":18,"width":18};